import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Employee } from '../models/employee';
import { UpdateEmployeePreparation } from '../models/update-employee-preparation';
import { TransferEmployee } from '../models/transfer-employee';
import { DirectWorkRequest } from '../models/direct-work-request';
import { UserFromEmp } from '../models/user-from-emp';

@Injectable({
    providedIn: 'root'
})

export class EmployeeService {

    controller = 'EmployeeService';
    constructor(private base: BaseService) { }

    addOrUpdateEmployee(obj: Employee): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/AddOrUpdateEmployee`, obj)
    }

    getEmployeesPaged(
        pageNumber: number,
        pageSize: number,
        sortByJobNumberAscending: boolean | null,
        jobNumberSearch: number | null,
        nameArSearch: string | null,
        PreparingTypeId: number | null,
    ): Observable<ApiObjectData> {
        let url = `services/app/${this.controller}/GetEmployeesPaged?pageNumber=${pageNumber}&pageSize=${pageSize}`;

        if (sortByJobNumberAscending !== null) {
            url += `&sortByJobNumberAscending=${sortByJobNumberAscending}`;
        }

        if (jobNumberSearch !== null) {
            url += `&jobNumberSearch=${jobNumberSearch}`;
        }

        if (nameArSearch !== null) {
            url += `&nameArSearch=${nameArSearch}`;
        }

        if (PreparingTypeId !== null) {
            url += `&PreparingTypeId=${PreparingTypeId}`;
        }


        return this.base.getById<ApiObjectData>(url);
    }

    getNewEmployeesPaged(pageNumber: number, pageSize: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmployees`, { pageNumber, pageSize });
    }

    getEmployeesbyUnitPaged(pageNumber: number, pageSize: number, unitId: any): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmployeesbyUnitPaged`, { pageNumber, pageSize, unitId });
    }

    getNewEmployeesbyUnitPaged(pageNumber: number, pageSize: number, unitId: any): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmployeesbyUnit`, { pageNumber, pageSize, unitId });
    }

    getEmpByIdDetails(id: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmpByIdDetails`, { id });
    }

    getEmpById(id: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmpByIdDetailsForEdit`, { id });
    }

    getEmployeesLkp(): Observable<ApiObjectData> {
        return this.base.gets<ApiObjectData>(`services/app/${this.controller}/GetEmployeesLkp`);
    }

    getEmployeesForExport(): Observable<ApiObjectData> {
        return this.base.gets<ApiObjectData>(`services/app/${this.controller}/GetEmployeesForExport`);
    }

    UpdateEmployee(obj: Employee): Observable<ApiObjectData> {
        return this.base.updateWithPut<ApiObjectData>(`services/app/${this.controller}/UpdateEmployee`, obj)
    }

    getAllPreparationTypes(): Observable<ApiObjectData> {
        return this.base.gets<ApiObjectData>(`services/app/${this.controller}/GetAllPreparationTypes`);
    }

    updateEmployeePreparation(obj: UpdateEmployeePreparation): Observable<ApiObjectData> {
        return this.base.updateWithPut<ApiObjectData>(`services/app/${this.controller}/UpdateEmployeePreparation`, obj)
    }

    getEmpByUnits(unitId: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmpByUnits`, { unitId });
    }

    getEmployeesbyJobNumber(jobNumber: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmployeesbyJobNumber`, { jobNumber });
    }

    transferEmployee(obj: TransferEmployee): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/TransferEmployee`, obj)
    }

    directWorkRequest(obj: DirectWorkRequest): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/DirectWorkRequest`, obj)
    }

    getTransferEmployeeRequests(pageNumber: number, pageSize: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetTransferEmployeeRequests`, { pageNumber, pageSize });
    }

    getTransferEmployeeRequestById(id: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetTransferEmployeeRequestById`, { id });
    }

    getEmpByIdForApproval(id: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmpByIdForApproval`, { id });
    }

    getTransferApprovedEmployee(id: number): Observable<ApiObjectData> {
        return this.base.saveById<ApiObjectData>(`services/app/${this.controller}/TransferApprovedEmployee`, id);
    }

    getDirectWorkRequests(pageNumber: number, pageSize: number, isOnVacation: boolean): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetDirectWorkRequests`, { pageNumber, pageSize, isOnVacation });
    }

    getDirectWorkDetailsForApproval(id: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetDirectWorkDetailsForApproval`, { id });
    }

    assignJobNumberToNewEmp(empId: number): Observable<ApiObjectData> {
        return this.base.assignById<ApiObjectData>(`services/app/${this.controller}/AssignJobNumberToNewEmp`, empId);
    }

    setVacationValueForEmployee(empId: number, isOnVacation: boolean): Observable<ApiObjectData> {
        return this.base.assignByIdForVac<ApiObjectData>(`services/app/${this.controller}/SetVacationValueForEmployee`, empId, isOnVacation);
    }

    checkExistingJobNumber(jobNumber: number): Observable<ApiObjectData> {
        return this.base.checkEmp<ApiObjectData>(`services/app/${this.controller}/CheckExistingJobNumber`, jobNumber);
    }

    checkExistingResidanceNumber(residentNo: number): Observable<ApiObjectData> {
        return this.base.checkResidance<ApiObjectData>(`services/app/${this.controller}/CheckExistingResidanceNumber`, residentNo);
    }

    checkExistingPassportNumber(passportNo: number): Observable<ApiObjectData> {
        return this.base.checkPassport<ApiObjectData>(`services/app/${this.controller}/CheckExistingPassportNumber`, passportNo);
    }

    resetEmployeeFingerPrint(empId: number): Observable<ApiObjectData> {
        return this.base.assignById<ApiObjectData>(`services/app/${this.controller}/ResetEmployeeFingerPrint`, empId);
    }

    getLastJobNumber(): Observable<ApiObjectData> {
        return this.base.gets<ApiObjectData>(`services/app/${this.controller}/GetLastJobNumber`);
    }

    createUserForEmp(obj: UserFromEmp): Observable<ApiObjectData> {
        return this.base.save<ApiObjectData>(`services/app/${this.controller}/CreateUserForEmp`, obj)
    }

    getEmployeeAssignments(empId: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetEmployeeAssignments`, { empId });
    }

    updateEmployeeIsOut(empId: number): Observable<ApiObjectData> {
        return this.base.updateEmployeeIsOut<ApiObjectData>(`services/app/${this.controller}/UpdateEmployeeIsOut`, empId);
    }


}